import tw from "tailwind-styled-components";
import { FaMoneyBill } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const CollectionSummary = ({ collectionStats }) => {
    const navigate = useNavigate();

    return (
        <Card>
            <Header>
                <IconWrapper>
                    <FaMoneyBill size={24} className="text-gray-500" />
                </IconWrapper>
                <Title>Collection</Title>
            </Header>

            <TotalAmount>₹{collectionStats.collection || 0}</TotalAmount>
            <Subtitle className='cursor-pointer' onClick={() => navigate('/landlord/collections')}>
                Total Collections
                <IoIosArrowForward
                    size={12}
                    className="ml-1 mt-0.5"
                />
            </Subtitle>

            <StatsGrid>
                <StatItem>
                    <StatNumber>₹{collectionStats.rentCollection || 0}</StatNumber>
                    <StatLabel>Rent </StatLabel>
                </StatItem>
                <StatItem className="lg:col-span-2">
                    <StatNumber>₹{collectionStats.securityCollection || 0}</StatNumber>
                    <StatLabel>Security </StatLabel>
                </StatItem>
            </StatsGrid>
            <FooterText>{"Security in hand : ₹" + (collectionStats?.securityInHand || 0)}</FooterText>
        </Card>
    );
};

const Card = tw.div`bg-white shadow-md rounded-lg p-6 gap-4`;
const Header = tw.div`flex items-center space-x-3 mb-4`;
const IconWrapper = tw.div`p-3 border border-gray-100 rounded-lg`;
const Title = tw.h3`text-lg font-semibold text-gray-800`;
const TotalAmount = tw.h1`text-4xl font-bold text-blue-500 mt-6`;
const Subtitle = tw.p`text-sm text-gray-500 flex items-center`;
const StatsGrid = tw.div`grid md:grid-cols-3 grid-cols-1 sm:grid-cols-2 mt-10 gap-6`;
const StatItem = tw.div``;
const StatNumber = tw.h4`text-lg font-semibold text-gray-800`;
const StatLabel = tw.p`text-sm text-gray-500 items-center`;
const FooterText = tw.p`text-xs text-gray-500 font-medium mt-6 mb-0`;

export default CollectionSummary;
